<script setup lang="ts">
import { onMounted } from 'vue'
import { usePushSubscribe } from '../composables/usePushSubscribe'
import { useNotifications } from '../composables/useNotifications'

const { supported, subscribed, busy, enable, disable, refresh } = usePushSubscribe()
const { showWarning, showError } = useNotifications()

onMounted(refresh)

async function toggle() {
  if (busy.value) return
  if (subscribed.value) { await disable(); return }
  const res = await enable()
  if (!res.ok) {
    if (res.reason === 'denied') {
      showWarning('Notifications are blocked for this site. Enable them in your browser’s site settings, then try again.')
    } else if (res.reason === 'unsupported') {
      showWarning('This browser doesn’t support push notifications.')
    } else {
      showError('Couldn’t enable notifications. Please try again.')
    }
  }
}
</script>

<template>
  <button
    v-if="supported"
    type="button"
    class="relative flex items-center justify-center w-9 h-9 rounded-lg text-secondary-600 hover:bg-secondary-100 transition-colors disabled:opacity-50"
    :disabled="busy"
    :title="subscribed ? 'Notifications on — click to turn off' : 'Enable push notifications on this device'"
    :aria-label="subscribed ? 'Disable push notifications' : 'Enable push notifications'"
    :aria-pressed="subscribed"
    @click="toggle"
  >
    <i :class="subscribed ? 'pi pi-bell text-primary-600' : 'pi pi-bell-slash text-secondary-400'" class="text-lg" />
    <span v-if="subscribed" class="absolute top-1 right-1 w-2 h-2 rounded-full bg-green-500"></span>
  </button>
</template>
